import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { rootRoute } from "./root-route"

export const swaggerRoute = createRoute( {
	wrapInSuspense: true,
	getParentRoute: () => rootRoute,
	path: "/swagger",
	component: lazyRouteComponent( () => import( "@/features/swagger/Swagger" ), "Swagger" ),
} )
